/* eslint-disable import/prefer-default-export */
export const CORRECT_CONFIRMATION_TEXT = 'deactivate me';